import { render, staticRenderFns } from "./widgetIframeCode.vue?vue&type=template&id=7615239e&scoped=true"
import script from "./widgetIframeCode.vue?vue&type=script&lang=js"
export * from "./widgetIframeCode.vue?vue&type=script&lang=js"
import style0 from "./widgetIframeCode.vue?vue&type=style&index=0&id=7615239e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7615239e",
  null
  
)

export default component.exports